<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>{{data.text}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{data.cancel ?? 'Cancel'}}</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button color="primary" mat-raised-button [mat-dialog-close]="true">{{data.ok ?? 'Ok'}}</button>
</mat-dialog-actions>
